package fyi.moko.hotpl.domain.usecase

import fyi.moko.hotpl.data.image.PlaceImageStore
import fyi.moko.hotpl.domain.repository.PlaceRepository

/** Deletes a place, its visit history, and its local photo file (if any). */
class DeletePlaceUseCase(
    private val repository: PlaceRepository,
    private val imageStore: PlaceImageStore,
) {
    suspend operator fun invoke(id: String) {
        val fileName = repository.getPlace(id)?.imageFileName
        repository.deletePlace(id)
        fileName?.let { imageStore.delete(it) }
    }
}
